/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".error[_ngcontent-%COMP%]{height:100%;display:flex;align-items:center;justify-content:center;flex-direction:column;flex-grow:1}.error[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{align-self:center;text-align:center;font-weight:700}.error[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{margin-top:20px}"];
export { styles as styles };
